import { lightTheme } from "../styles/theme";
import { useColorScheme } from "./useColorScheme";

export const useTheme = () => {
  const theme = useColorScheme();

  return lightTheme;
};
